module.exports = __webpack_public_path__ + "img/trap.3d01b2a2.png";